import { observer } from "mobx-react-lite";
import { Form as FinalForm, Field } from "react-final-form";
import React, { useContext, useState } from "react";

// reactstrap components
import { Alert, Button, FormGroup, Form, Row, Col } from "reactstrap";
import { IResetPwdFormValues } from "../../app/models/user";
import { FORM_ERROR } from "final-form";
import { RootStoreContext } from "../../app/stores/rootStore";
import TextInput from "../common/TextInput";
import { combineValidators, isRequired } from "revalidate";
import LogoCompany from "../common/LogoCompany";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";

const validate = combineValidators({
  email: isRequired("email"),
});

export const ResetPwdForm = () => {
  const rootStore = useContext(RootStoreContext);
  const { showRegisterForm, showLoginForm } = rootStore.authStore;
  const { resetPwd } = rootStore.userStore;
  const { company } = rootStore.commonStore;
  const [emailSent, setEmailSent] = useState(false);
  const [t] = useTranslation(["translation"], translationHookOptions);

  const linkToRegister = (
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => {
    e.preventDefault();
    showRegisterForm();
  };

  const linkToLogin = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    e.preventDefault();
    showLoginForm();
  };

  return (
    <div className="form-wrapper  mt-0">
      <div>
        <LogoCompany className="loginLogo" />
      </div>
      <h5>{t("change_pwd_insert_email_text")}</h5>
      <FinalForm
        initialValues={{
          email: "",
          companyId: company ? company.id : 1,
          IsPlayer: true,
        }}
        onSubmit={(values: IResetPwdFormValues) =>
          resetPwd(values)
            .then(() => setEmailSent(true))
            .catch((error) => ({
              [FORM_ERROR]: error,
            }))
        }
        validate={validate}
        render={({
          handleSubmit,
          submitting,
          submitError,
          invalid,
          pristine,
          dirtySinceLastSubmit,
        }) => (
          <Form onSubmit={handleSubmit} role="form">
            <FormGroup className="form-group input-group-lg">
              <Field
                name="email"
                component={TextInput}
                placeholder={t("email_placeholder")}
                type="email"
              />
            </FormGroup>
            {submitError && !dirtySinceLastSubmit && (
              <Alert color="danger">{t("invalid_email")}</Alert>
            )}
            {emailSent && (
              <Alert color="success">
                {t("reset_pwd_email_sent")}
              </Alert>
            )}
            <div className="text-center">
              <Button
                disabled={(invalid && !dirtySinceLastSubmit) || pristine}
                className="btn loginButton btn-block btn-lg"
                color="dark"
                type="submit"
              >
                {t("continue")}
              </Button>
            </div>
          </Form>
        )}
      />

      <Row className="mt-3">
        <Col>
          <p className="text-muted">{t("registration_already_registered")}</p>
          <a
            className="btn btn-dark loginButton text-white btn-outline-light btn-sm"
            href="/#"
            onClick={(e) => linkToLogin(e)}
          >
            {t("login")}
          </a>
        </Col>
        {company && company.allowRegistration && (
          // <Col>
          //   <p className="text-muted">{t("registration_text")}</p>
          //   <a
          //     className="btn btn-outline-light btn-sm"
          //     href="/#"
          //     onClick={(e) => linkToRegister(e)}
          //   >
          //     {t("registration_link")}
          //   </a>
          // </Col>
          <Col>
          <a
            className="text-muted text-underline"
            href="/#"
            onClick={(e) => linkToRegister(e)}
          >
           {t("registration_text")}  {t("registration_link")}
          </a>
          </Col>
        )}
      </Row>
    </div>
  );
};

export default observer(ResetPwdForm);
